import Vue from 'vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale'
import i18n from "../i18n";
locale.use(i18n.locale)

Vue.use(Element)
